<template>
  <div class="platform-selector">
    <v-menu v-model="dropdownOpen" :close-on-content-click="false" offset-y max-width="100%">
      <template #activator="{ props }">
        <v-text-field v-bind="props" :value="selectedDisplay.join(', ')" readonly outlined hide-details
          placeholder="Select Page Identity" class="mb-4" color="primary" density="compact" />
      </template>

      <v-card class="pa-4 dropbox">
        <div v-for="platform in platforms" :key="platform.name" class="mb-3 rounded-lg overflow-hidden">
          <div class="d-flex justify-space-between align-center px-4 py-3" @click="togglePlatform(platform.name)"
            style="cursor: pointer">
            <div class="d-flex align-center">
              <v-avatar size="24" class="mr-2">
                <img :src="platform.icon" alt="icon" />
              </v-avatar>
              <span class="font-weight-medium">{{ platform.display }}</span>
            </div>
            <v-icon>
              {{
                openedPlatform === platform.name
                  ? "mdi-chevron-up"
                  : "mdi-chevron-down"
              }}
            </v-icon>
          </div>

          <v-expand-transition>
            <div v-if="openedPlatform === platform.name" class="px-2 pt-3">
              <v-radio-group v-model="selectedAccounts[platform.name]">
                <v-radio v-for="page in platform.pages" :key="page.id" :value="page.id" class="my-2">
                  <template #label>
                    <div class="d-flex align-center">
                      <v-avatar class="mr-2" style="width: 2.5rem; height: 2.5rem">
                        <img :src="page.avatar" alt="avatar" class="w-100" />
                      </v-avatar>
                      {{ page.name }}
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </div>
          </v-expand-transition>
        </div>

        <div class="d-flex justify-end">
          <v-btn class="clear-btn" @click="clearSelections()">clear</v-btn>
          <v-btn class="done-btn" @click="dropdownOpen = false">Done</v-btn>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import apiClient from "@/core/buildRequest";

export default {
  data() {
    return {
      dropdownOpen: false,
      openedPlatform: null,
      selectedAccounts: {},
      platforms: [],
    };
  },
  props: {
    identity: String,
  },
  emits: ["update:identity"],
  mounted() {
    this.fetchPlatforms();
  },
  computed: {
    selectedDisplay() {
      const selected = [];
      for (const platform of this.platforms) {
        const selectedId = this.selectedAccounts[platform.name];
        const account = platform.pages.find((p) => p.id === selectedId);
        if (account) {
          selected.push(`${platform.display}: ${account.name}`);
        }
      }
      return selected;
    },
    displayText() {
      return this.selectedDisplay.join(", ");
    },
  },
  watch: {
    selectedAccounts: {
      handler(newVal) {
        const detailed = {};
        for (const platform of this.platforms) {
          const selectedId = newVal[platform.name];
          const page = platform.pages.find((p) => p.id === selectedId);
          if (page) {
            detailed[platform.name] = {
              id: page.id,
              name: page.name,
              avatar: page.avatar,
            };
          }
        }

        // ✅ نحتفظ بتخزين الهوية في localStorage كما هو
        localStorage.setItem(
          "selected_identity_accounts",
          JSON.stringify(detailed)
        );

        // ✅ إضافة Emit لهوية أول منصة تم اختيارها
        const firstSelected = Object.values(detailed)[0];
        if (firstSelected?.id) {
          this.$emit("update:identity", firstSelected.id);
        } else {
          this.$emit("update:identity", null);
        }
      },
      deep: true,
    },
  },
  methods: {
    togglePlatform(name) {
      this.openedPlatform = this.openedPlatform === name ? null : name;
    },

    async fetchPlatforms() {
      try {
        const raw = localStorage.getItem("superselected_accounts");
        if (!raw) return;

        const selected = JSON.parse(raw);

        const response = await apiClient.get("/super-ad/get/identities", {
          params: {
            facebook_account_id: selected.facebook?.id,
            instagram_account_id: selected.instagram?.id,
            tiktok_account_id: selected.tiktok?.id,
            snapchat_account_id: selected.snapchat?.id,
          },
        });

        const result = response.data;
        console.log(result, "result");

        if (result.key === "success" && Array.isArray(result.data)) {
          const platformsMap = {
            facebook: {
              name: "facebook",
              display: "Facebook",
              icon: require("@/assets/images/icons/meta.png"),
              pages: [],
            },
            instagram: {
              name: "instagram",
              display: "Instagram",
              icon: require("@/assets/images/icons/instagram.svg"),
              pages: [],
            },
            tiktok: {
              name: "tiktok",
              display: "Tik Tok",
              icon: require("@/assets/images/icons/tiktok.png"),
              pages: [],
            },
            snapchat: {
              name: "snapchat",
              display: "Snapchat",
              icon: require("@/assets/images/icons/snap.png"),
              pages: [],
            },
          };
          console.log("platformsMap");
          result.data.forEach((item) => {
            const platformKey = item.platform?.toLowerCase().trim();
            if (platformKey && platformsMap[platformKey]) {
              platformsMap[platformKey].pages.push({
                id: item.id,
                name: item.name,
                avatar: item.image,
              });
            }
          });

          this.platforms = Object.values(platformsMap).filter(
            (p) => p.pages.length > 0
          );
          this.platforms.forEach((p) => {
            if (!(p.name in this.selectedAccounts)) {
              this.selectedAccounts[p.name] = null;
            }
          });

        }
      } catch (e) {
        console.error("Failed to fetch identities:", e);
      }
    },
    clearSelections() {
      for (const platform of this.platforms) {
        this.selectedAccounts[platform.name] = null;
      }
      localStorage.removeItem("selected_identity_accounts");
    },
    getSelectedAccounts() {
      return this.selectedAccounts;
    },
  },
};
</script>

<style scoped>
.platform-selector {
  position: relative;
}

.dropdown-wrapper {
  position: relative;
}

.dropbox {
  box-shadow: 0px 4px 8px rgba(125, 124, 124, 0.25);
  border-radius: 12px;
  background: #fff;
  position: absolute;
  z-index: 9999;
  width: 100%;
  min-height: max-content !important;
}

.done-btn {
  background-color: #237276 !important;
  color: white !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  height: 32px !important;
  padding: 0 32px !important;
  border-radius: 8px !important;
  text-transform: none !important;
}

.clear-btn {
  background-color: #e7e7e7 !important;
  color: #222222 !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  height: 32px !important;
  padding: 0 32px !important;
  border-radius: 8px !important;
  text-transform: none !important;
  box-shadow: none !important;
  margin-right: 0.3rem !important;
}

/* ::v-deep(.v-input) {
  background-color: #fff !important;
  border-radius: 8px !important;
  height: 3.2rem;
  cursor: pointer;
  border: 1px solid #ccc !important;
  box-shadow: none !important;
} */

::v-deep(.v-input) {
  background-color: #fff !important;
  border-radius: 8px !important;
  border: 1px solid #237276 !important;
  cursor: pointer;
}

::v-deep(.v-field__field) {
  padding: 0 !important;
  font-size: 14px !important;
  color: #111 !important;
}

::v-deep(.v-label) {
  font-weight: 500 !important;
  font-size: 13px !important;
}

::v-deep(.v-radio-group .v-input__details) {
  display: none !important;
}

::v-deep(.v-field--variant-filled .v-field__overlay) {
  background-color: #fff !important;
  border: 1px solid #ddd !important;
  border-radius: 0.3rem !important;
}

.dropbox ::v-deep(.v-input--horizontal) {
  background-color: #f2f2f299 !important;
  border: none !important;
  padding: 1rem;
  height: auto !important;
}

::v-deep(.v-selection-control__input .v-icon) {
  color: #237276 !important;
}
</style>
